import { Publisher } from '@screens/landing-page-team/types';
import * as Styles from '@screens/lp-default/components/team/components/publisher-card/styles';
import { tabsAndContents } from '@screens/lp-default/components/team/constants';

type PublisherCardProps = {
  publisher: Publisher;
  tab: string;
};

export default function PublisherCard({ publisher, tab }: PublisherCardProps) {
  const cardWidth = tab === tabsAndContents[0].tab ? '320px' : '212px';
  return (
    <Styles.Container data-testid="team-card" width={cardWidth}>
      {publisher.image && (
        <Styles.PublisherCardImage
          src={`/images/default-landing-page/team/${publisher.image}`}
          height={80}
          width={80}
          alt={publisher.name}
          title={publisher.name}
        />
      )}
      <Styles.InfoWrapper>
        <Styles.PublisherCardName>{publisher.name}</Styles.PublisherCardName>
        {publisher.role && <Styles.PublisherCardRole>{publisher.role}</Styles.PublisherCardRole>}
        {publisher.specialty && <Styles.PublisherCardSpecialty>{publisher.specialty}</Styles.PublisherCardSpecialty>}
      </Styles.InfoWrapper>
    </Styles.Container>
  );
}
